<template>
  <div class="warn-container">
    <img src="../../assets/pc/warn.png">
    <span v-html="homeLang.warn.content"></span>
    <a class="learn" :href="homeLang.warn.url" target="_blank">{{ homeLang.warn.text }}</a>
  </div>
</template>

<script>
export default {
  name: "warn",
  props: {
    homeLang: {
      type: Object
    }
  },
}
</script>


<style lang="less">
.warn-container {
  font-size: 16px;
  padding: 10px 0;
  background: #FFF1D4;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 24px;
    margin-right: 8px;
  }
  .learn {
    padding: 8px 32px;
    border-radius: 15px;
    background: #FF7114;
    font-size: 12px;
    font-family: PingFang SC, PingFang SC-Medium;
    color: #ffffff;
    margin-left: 16px;
    cursor: pointer;
    white-space: nowrap;
  }
  .bold {
    font-weight: bold;
  }
}
@media screen and (max-width: 768px) {
  .warn-container {
    font-size: 14px;
    padding: 10px 10px;
    word-break: break-all;
    .learn {
      padding: 8px 15px;
      display: block;
      white-space: nowrap;
    }
  }
}
@media screen and (max-width: 380px){
  .warn-container {
    transform: scale(0.75);
    transform-origin: 0 0;
    width: 133.3%;
  }
}
@media screen and (max-width: 300px){
  .warn-container {
    transform: scale(0.666);
    transform-origin: 0 0;
    width: 150%;
  }
}
</style>
